import { render, staticRenderFns } from "./Dealer.vue?vue&type=template&id=a4f98fbc"
import script from "./Dealer.vue?vue&type=script&lang=ts"
export * from "./Dealer.vue?vue&type=script&lang=ts"
import style0 from "./Dealer.vue?vue&type=style&index=0&id=a4f98fbc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports